// removed by extract-text-webpack-plugin
module.exports = {"review":"theme__review___2zHU3","strongest":"theme__strongest___3Bpua","fadeUp":"theme__fadeUp___1MnxC","header":"theme__header___2kRFv","heading":"theme__heading___16eU5","check":"theme__check___3nJmi","elements":"theme__elements___cPvUx","action":"theme__action___1KlVB","button":"theme__button___2jE_j","lateFadeUp":"theme__lateFadeUp___3HnCJ","lateFadeIn":"theme__lateFadeIn___2uQcX"};


//////////////////
// WEBPACK FOOTER
// ./client/modules/debate/components/Review/theme.scss
// module id = 1304
// module chunks = 0